/*global __CLIENT__*/
import React, { PureComponent } from 'react';
import styled from 'styled-components';

const NotAuthorized = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  flex: 1 0 100%;
  flex-direction: column;
  padding: 50px;
`;

export default class NotAuth extends PureComponent {
  render() {
    return (
      <NotAuthorized>
        <i className="fa fa-ban fa-4x mb-2" aria-hidden="true" />
        <h3>Not Authorized.</h3>
      </NotAuthorized>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotAuthorized.js